import React from 'react';
import { Check } from 'lucide-react';

function DomainVisual() {
  return (
    <>
      <div className="process-visual-head">
        <span style={{ color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>Domain warm-up</span>
        <span className="ok">✓ Healthy</span>
      </div>
      <div className="domain-row"><span className="dn">acme-mail.co</span><span className="pct">92%</span></div>
      <div className="domain-row"><span className="dn">acme-reach.co</span><span className="pct">88%</span></div>
      <div className="domain-row"><span className="dn">acme-reply.co</span><span className="pct">95%</span></div>
      <div className="dns-badges"><span>SPF ✓</span><span>DKIM ✓</span><span>DMARC ✓</span></div>
    </>
  );
}

function DecisionMakersVisual() {
  return (
    <>
      <div className="dm-pulse">
        <div className="ring r1" />
        <div className="ring r2" />
        <div className="ring r3" />
        <div className="dm-count">4,812</div>
      </div>
      <div className="dm-label">Decision-makers matched</div>
    </>
  );
}

function CampaignVisual() {
  return (
    <>
      <div className="campaign-row">
        <div className="hd"><span className="l">Opener · variant A</span><span className="r">12.4% reply</span></div>
        <p>Noticed <span className="var">{'{{firstName}}'}</span> you just launched your<br/><span className="var">{'{{intent_signal}}'}</span>, curious how you're handling inbound from it.</p>
      </div>
      <div className="campaign-row">
        <div className="hd"><span className="l">Follow-up · variant B</span><span className="r">testing</span></div>
        <p>Worth a quick look at how <span className="var">{'{{similar_company}}'}</span> solved the same problem last quarter?</p>
      </div>
      <div className="campaign-foot"><span className="ai">AI-personalized</span><span>· 2,000 prospects / mo</span></div>
    </>
  );
}

function LaunchVisual() {
  return (
    <div className="meetings-live">
      <div className="meetings-row">
        <div>
          <div className="l">Meetings this week</div>
          <div className="v">18 <span className="d">+42%</span></div>
        </div>
        <span className="live">Live</span>
      </div>
      <div className="week-bars">
        <div className="wb"/><div className="wb"/><div className="wb"/><div className="wb"/><div className="wb"/><div className="wb"/><div className="wb"/>
      </div>
      <div className="week-labels">
        <span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span>
      </div>
    </div>
  );
}

const steps = [
  { num: '01', day: 'Day 1–14', stage: 'Infrastructure', title: 'We wire your entire outbound stack', desc: 'Dedicated sending domains, deliverability warm-up, CRM integration, inbox rotation, tracking. A production-grade system from day one.', visual: <DomainVisual /> },
  { num: '02', day: 'Day 3–5', stage: 'Market Targeting', title: 'We compile your ideal-client universe', desc: 'Scraping, enrichment, intent layering. A living database of every decision-maker inside your Total Addressable Market.', visual: <DecisionMakersVisual /> },
  { num: '03', day: 'Day 5–10', stage: 'Campaign Creation', title: 'We craft messaging that converts', desc: 'Audience-specific angles, AI-personalized at scale, A/B variants baked in. Every campaign is built for your offer.', visual: <CampaignVisual /> },
  { num: '04', day: 'Day 14 onwards', stage: 'Launch & Optimize', title: 'We ship, monitor, and tune live', desc: 'Campaigns go live. We watch reply rates and meetings booked, tuning daily until your calendar is full.', visual: <LaunchVisual /> },
];

export default function Process() {
  return (
    <section id="process">
      <div className="container-x">
        <div className="section-intro">
          <span className="eyebrow reveal">The Process</span>
          <h2 className="section-heading reveal reveal-delay-1" style={{ marginTop: 24 }}>
            From zero to a <span className="text-gradient">booked calendar</span> in 14 days.
          </h2>
          <p className="reveal reveal-delay-2">A simple, repeatable four-stage framework. Each stage is built, measured, and handed off, so nothing sits in a to-do list.</p>
        </div>
        <div className="process-steps">
          {steps.map((s, i) => (
            <article key={i} className="process-step reveal">
              <div>
                <div className="process-num">{s.num}</div>
                <div className="process-meta">
                  <span className="tag">Step {s.num} · {s.day}</span>
                  <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.5)' }}>{s.stage}</span>
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
              <div className="process-visual">
                {s.visual}
              </div>
            </article>
          ))}
        </div>
        <p className="process-tagline reveal">Your first qualified meeting typically lands within days of launch.</p>
      </div>
    </section>
  );
}
